import { Typography } from '@mui/material';
import { ANROK_DEFAULT_TAX_METHOD, type AnrokDefaultTaxMethod } from '@vy/integrations-types';
import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import { VySelect } from '../../../../../../../../components/new-design/atoms';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import type {
  AnrokConfigurationControl,
  AnrokConfigurationFormValues,
} from '../../AnrokConfigurationFormSchema';

type Props = {
  control: AnrokConfigurationControl;
  defaultValues: AnrokConfigurationFormValues;
};

type TaxMethodOption = {
  key: AnrokDefaultTaxMethod;
  label: string;
};

const TAX_METHOD_OPTIONS: TaxMethodOption[] = [
  {
    key: ANROK_DEFAULT_TAX_METHOD.AUTO,
    label: 'Automatic Tax using Anrok (recommended)',
  },
  {
    key: ANROK_DEFAULT_TAX_METHOD.MANUAL,
    label: 'Manual Tax',
  },
];

export const DefaultTaxMethodSection: FC<Props> = ({ control, defaultValues }) => {
  return (
    <ConfigurationSection title="Default Tax Method" iconName="Settings">
      <Controller
        name="defaultTaxMethod"
        control={control}
        defaultValue={defaultValues.defaultTaxMethod}
        render={({ field: { value, onChange } }) => (
          <VySelect
            label={<Typography sx={{
              fontSize: 12
            }}>Tax Method</Typography>}
            options={TAX_METHOD_OPTIONS}
            selectedOption={TAX_METHOD_OPTIONS.find((opt) => opt.key === value)}
            onSelectionChange={(item) => {
              if (item) {
                onChange(item.key);
              }
            }}
            keyExtractor={(o) => o.key}
            render={(o) => <Typography>{o.label}</Typography>}
            fullWidth
          />
        )}
      />
    </ConfigurationSection>
  );
};
